import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth/services/auth.service';
import { SessionService } from './auth/services/session.service';
import { GlobalStateService } from './shared/services/global-state.service';
import { StartService } from './pages/startsida/start.service';
import { StandardNameUpdateStateService } from './pages/startsida/standard-name-update-state.service';
import { filter, take } from 'rxjs/operators';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent  {
  menuOpen = true;
  isLoggedIn$ = this.sessionService.loggedInSingleOrg$;

  constructor(
    private auth: AuthService,
    private router: Router,
    private sessionService: SessionService,
    private http: HttpClient,
    protected globalStateService: GlobalStateService,
    private startService: StartService,
    private updateState: StandardNameUpdateStateService
  ) {}

  ngOnInit() {
    this.sessionService.loggedInSingleOrg$
      .pipe(
        filter(isLoggedIn => isLoggedIn === true)
      )
      .subscribe(() => {
        this.startService.getStandardNameUpdates()
          .subscribe(updates => {
            this.updateState.initFromBackend(updates);
          });
      });
  }

  importPrimeNgCalendarTranslation() {
    return this.http.get('/assets/locale/primeng-calendar-sv.json');
  }

  private logout() {
    this.auth.logout();
    this.sessionService.logout();
    this.router.navigate(['/']);
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }
}
